import React from 'react';
import '@/App.css';
import { Header } from '@/components/sections/Header';
import { Hero } from '@/components/sections/Hero';
import { DigitalTransformation } from '@/components/sections/DigitalTransformation';
import { AIPower } from '@/components/sections/AIPower';
import { RegulatoryCompliance } from '@/components/sections/RegulatoryCompliance';
import { HowItWorks } from '@/components/sections/HowItWorks';
import { BenefitsTabs } from '@/components/sections/BenefitsTabs';
import { CTASection } from '@/components/sections/CTASection';
import { Footer } from '@/components/sections/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <DigitalTransformation />
        <AIPower />
        <RegulatoryCompliance />
        <HowItWorks />
        <BenefitsTabs />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;